// @flow
import { useRef, useCallback } from 'react';
import debounce from '../utils/debounce';
import type { DebouncedFunction } from '../utils/debounce';

function useDebounce<T: (...args: any[]) => any>(
  callback: T,
  delay: number,
  immediate?: boolean
): DebouncedFunction<T> {
  const debouncedFn = useRef<DebouncedFunction<T> | null>(null);

  const debouncedCallback = useCallback(
    (...args: Parameters<T>) => {
      if (!debouncedFn.current) {
        debouncedFn.current = debounce(callback, delay, immediate);
      }
      debouncedFn.current(...args);
    },
    [callback, delay, immediate]
  );

  return debouncedCallback;
}

export default useDebounce;
